//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IOpObject, IReferenceType, IOpChangeState, IOpData } from '../util/interfaces'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'
import { ObjectCustomString } from '../../models/util/object-custom-string'

import { OpDataList } from '../util/op-data-list'
import { OpDataType } from './op-data-type'
import { OpData } from './op-data'
import { OpDeviceType } from './op-device-type'
import { OpMeter } from './op-meter'
import { OpLocation } from './op-location'
import { Utils } from '../util/utils'

export class OpDevice implements IReferenceType, IOpObject, IOpChangeState {

    // #region Properties

    public serialNbr: number
    public idDeviceType: number
    public idDistributor: number
    public idDeviceStateType: number

    // #endregion


    // #region Navigation Properties

    private deviceType: OpDeviceType

    // #endregion


    // #region Custom Properties

    public currentLocations: OpLocation[] = []
    public currentMeters: OpMeter[] = []

    public currentLocationsDict: Dictionary<OpLocation>
    public currentMetersDict: Dictionary<OpMeter>

    public get currentMeter(): OpMeter {
        return this.currentMeters != null && this.currentMeters.length > 0
            ? this.currentMeters[0]
            : null
    }

    // #endregion Custom Properties End

    // #region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // #endregion


    // #region IOpChangeState Implementation

    public opState: Enums.OpChangeState

    // #endregion


    // #region IReferenceType Implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.SerialNbr
    }
    public getReferenceKey(): number {
        return this.serialNbr
    }
    public getReferenceValue(): any {
        return this
    }

    // #endregion

    // #region IOpObject Implementation

    public get idObject(): any {
        return this.serialNbr
    }

    public set idObject(value: any) {
        this.serialNbr = value
    }

    public dataList: OpDataList<OpData> = new OpDataList<OpData>()

    public dynamicValues: { Key: string, Value: any }[] = []

    public customFormatString: string

     public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.serialNbr = opObj.SERIAL_NBR
            this.idDeviceType = opObj.ID_DEVICE_TYPE
            this.idDistributor = opObj.ID_DISTRIBUTOR
            this.idDeviceStateType = opObj.ID_DEVICE_STATE_TYPE

            this.currentLocations = opObj.CurrentLocations != null ? opObj.CurrentLocations.map((location: any) => new OpLocation(location)) : []
            this.currentMeters = opObj.CurrentMeters != null ? opObj.CurrentMeters.map((meter: any) => new OpMeter(meter)) : []

            this.deviceType = opObj._DeviceType != null ? new OpDeviceType(opObj._DeviceType) : null

            if (opObj.DataList) {
                this.dataList.push(...opObj.DataList.map(data => new OpData(data)))
            }

            this.dynamicValues = opObj.dynamicValues
            this.opState = opObj.OpState
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            SERIAL_NBR: this.serialNbr,
            ID_DEVICE_TYPE: this.idDeviceType,
            ID_DISTRIBUTOR: this.idDistributor,
            ID_DEVICE_STATE_TYPE: this.idDeviceStateType,

            CurrentLocations: this.currentLocations != null ? this.currentLocations.map((location: OpLocation) => location.toJSON()) : [],
            CurrentMeters: this.currentMeters != null ? this.currentMeters.map((meter: OpMeter) => meter.toJSON()) : [],

            CurrentLocationsDict: Utils.serializeDictionary(this.currentLocationsDict),
            CurrentMetersDict: Utils.serializeDictionary(this.currentMetersDict),

            dynamicValues: this.dynamicValues,
            DataList: this.dataList.ToJSON(),
            OpState: this.opState
        }
    }

    public toString() {
        var retStr = ''
        var customFormatString = ObjectCustomString.getCustomStringFormat(this)
        if (!customFormatString) {
            if (this.deviceType) {
                retStr = this.deviceType.toString() + ': ' + this.serialNbr
            } else {
                retStr = this.serialNbr + ''
            }
        }
        else {
            retStr = ObjectCustomString.getObjectCustomString(customFormatString, this)
        }
        return retStr
    }

    // #endregion

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpDevice[]): JQueryPromise<OpDevice[]> {
        const defered: JQueryDeferred<OpDevice[]> = $.Deferred<OpDevice[]>()

        if (dataProvider && list && list.length > 0) {
            const idDataType: number[] = CommonHelper.getIdDataTypesFromObjectList<OpDevice>(list)
            dataProvider.System.getDictionaries([Enums.ReferenceType.IdDataType]).then(dict => {
                let dataTypeDict: Dictionary<OpDataType> = new Dictionary<OpDataType>(null)
                if (dict.containsKey(Enums.ReferenceType.IdDataType)) {
                    dataTypeDict = <Dictionary<OpDataType>>dict.tryGetValue(Enums.ReferenceType.IdDataType)
                }

                list.forEach(item => {
                    if (item.dataList) {
                        item.dataList
                            .toArray()
                            .forEach((data: IOpData) => {
                                data.dataType = dataTypeDict.tryGetValue(data.idDataType)
                            })
                    }
                })

                defered.resolve(list)
            })
        } else {
            defered.resolve(list)
        }

        return defered.promise()
    }

    public static fromIOpObject(object: IOpObject): OpDevice {
        const newObject: OpDevice = new OpDevice(null)

        newObject.serialNbr = object.idObject
        newObject.opState = object.opState
        newObject.dataList.push(...object.dataList.toArray().map((d: IOpData) => OpData.fromIOpData(d)))

        return newObject
    }
}
